import { useCallback } from "react";
import { useIntl } from "react-intl";
import SweetAlert, { SweetAlertOptions } from "sweetalert2";
import { APP_COLORS } from "../../../witadmin/Common/constants";
import { loyaltyTagSectionEditMessages } from "../../EditSection/LoyaltyTagSectionEdit.messages";

export enum ModalActionType {
  SUCCESS_CREATE,
  ERROR_CREATE,
  SUCCESS_UPDATE,
  ERROR_UPDATE,
}

export interface ModalAction {
  type: ModalActionType;
  data?: Record<string, number>;
}

export function useModal() {
  const intl = useIntl();

  const getModalPropsByAction = useCallback(
    (action: ModalAction): SweetAlertOptions => {
      switch (action.type) {
        case ModalActionType.SUCCESS_CREATE:
          return {
            title: intl.formatMessage(loyaltyTagSectionEditMessages.createSuccessTitle),
            text: intl.formatMessage(loyaltyTagSectionEditMessages.createSuccessDescription),
            confirmButtonColor: APP_COLORS.primary,
            icon: "success",
          };
        case ModalActionType.ERROR_CREATE:
          return {
            title: intl.formatMessage(loyaltyTagSectionEditMessages.createErrorTitle),
            text: intl.formatMessage(loyaltyTagSectionEditMessages.createErrorDescription),
            confirmButtonColor: APP_COLORS.primary,
            icon: "error",
          };
        case ModalActionType.SUCCESS_UPDATE:
          return {
            title: intl.formatMessage(loyaltyTagSectionEditMessages.updateSuccessTitle),
            text: intl.formatMessage(loyaltyTagSectionEditMessages.updateSuccessDescription),
            confirmButtonColor: APP_COLORS.primary,
            icon: "success",
          };
        case ModalActionType.ERROR_UPDATE:
          return {
            title: intl.formatMessage(loyaltyTagSectionEditMessages.updateErrorTitle),
            text: intl.formatMessage(loyaltyTagSectionEditMessages.updateErrorDescription),
            confirmButtonColor: APP_COLORS.primary,
            icon: "error",
          };

        default:
          throw new Error(`Invalid action ${action}`);
      }
    },
    [intl]
  );

  const showModal = useCallback(
    async (action: ModalAction, onConfirm: () => void) => {
      const result = await SweetAlert.fire(getModalPropsByAction(action));
      if (result.isConfirmed || result.isDismissed || result.isDenied) {
        onConfirm();
      }
    },
    [getModalPropsByAction]
  );

  return { showModal };
}
